import { render, staticRenderFns } from "./FormHotkey.vue?vue&type=template&id=8eb556e8&scoped=true"
import script from "./FormHotkey.vue?vue&type=script&lang=js"
export * from "./FormHotkey.vue?vue&type=script&lang=js"
import style0 from "./FormHotkey.vue?vue&type=style&index=0&id=8eb556e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb556e8",
  null
  
)

export default component.exports